import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from "./store";

import '@/assets/styles.css';
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import {onScroll} from './utils/directives/onScroll';
import Axios from "axios";
import Select2 from 'vue3-select2-component';
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'
import 'owl.carousel';
import "animate.css";

Axios.defaults.baseURL = 'https://uaeafter2pm.org/';
//Axios.defaults.baseURL = 'http://127.0.0.1:8000/';

createApp(App)
    .use(router)
    .use(store)
    .component('Select2', Select2)
    .component('Datepicker', Datepicker)
    .directive('on-scroll', onScroll)
    .mount('#app');
